import { createStyles, rem } from '@mantine/core'

type StyleParams = {
  backgroundColor: string
}

export default createStyles((theme, { backgroundColor }: StyleParams) => {
  return {
    root: {
      backgroundColor: backgroundColor || theme.colors.gray[1],
      display: 'flex',
      flexDirection: 'column',
      gap: 20,
      padding: `${rem(20)} 0`,
      [theme.fn.largerThan('sm')]: {
        padding: `${rem(40)} 0`,
        gap: 40,
      },
    },
    header: {
      color: theme.colors.gray[8],
      [theme.fn.largerThan('sm')]: {
        padding: `${rem(8)} 0`,
        textAlign: 'center',
      },
    },
  }
})
